export const PUSH_NOTIFICATIONS_SUGGESTION_SHOWN = 'PUSH_NOTIFICATIONS_SUGGESTION_SHOWN';
